import {useWbAgentClient} from '@wandb/weave/lib/WbAgent/useWbAgentClient';
import {useCallback} from 'react';

import {renameThread} from '../../../agentChat/mutations/renameThread';
import {
  useAgentChatDispatch,
  useAgentChatStore,
} from '../../../agentChat/store/context';
import {useNavContext} from '../../NavContextProvider';

/** useRenameThread returns a function that optimistically renames a thread. */
export function useRenameThread() {
  const {params} = useNavContext();
  const client = useWbAgentClient(params.entityName, params.projectName);
  const dispatch = useAgentChatDispatch();
  // eslint-disable-next-line wandb/zustand-use-store-selectors - not a zustand store.
  const store = useAgentChatStore();

  return useCallback(
    (threadId: string, title: string): Promise<void> => {
      if (!client) {
        return Promise.resolve();
      }

      return renameThread({client, dispatch, store, threadId, title});
    },
    [client, dispatch, store]
  );
}
